import { render } from "./TheCartPositions.vue?vue&type=template&id=3b377dea"
import script from "./TheCartPositions.vue?vue&type=script&lang=js"
export * from "./TheCartPositions.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__